import ButtonIcon from 'components/ButtonIcon';
import styled from 'styled-components';
import { color, shadow } from 'theme';

export const StyledVideoContainer = styled.div`
    position: relative;
    margin: 5px 0;
`;

export const StyledVideo = styled.video`
    border-radius: 10px;
`;

export const StyledPlayContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledControls = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    bottom: 4px;
    left: 4px;
    right: 4px;
    background-color: rgba(74, 68, 88, 0.8);
    height: 32px;
    border-radius: 8px;
    padding: 4px;
    color: #fff;
    font-size: 12px;
    gap: 2px;
`;

export const StyledPlayButton = styled(ButtonIcon)`
    width: 1.25rem;
    height: 1.25rem;

    svg {
        width: 14px !important;
        height: 14px !important;
    }
`;

export const StyledTime = styled.span`
    color: #fff;
`;

export const StyledInputRange = styled.input`
    appearance: none;
    width: 100%;
    margin: 0.5rem 0;
    background: transparent;
    border-radius: 0.4rem;
    box-sizing: border-box;
    color: inherit;
    font: inherit;
    line-height: normal;
    flex: 1;

    ::-moz-focus-inner {
        border: 0;
        padding: 0;
    }

    &::-webkit-slider-thumb {
        appearance: none;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #fff;
        border: 0;
        box-shadow: ${shadow('shadow_1')};
        cursor: pointer;
        transition: all 0.3s ease 0s;
        margin-top: -1px;
    }

    &::-webkit-slider-runnable-track {
        width: 100%;
        height: 4px;
        cursor: pointer;
        background: rgba(255, 255, 255, 0.37);
        border-radius: 16px;
    }

    &::-moz-range-thumb {
        appearance: none;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #fff;
        border: 0;
        box-shadow: ${shadow('shadow_1')};
        cursor: pointer;
        transition: background-color 0.15s ease-in-out;
        margin-top: -1px;
    }

    &::-moz-range-track {
        width: 100%;
        height: 4px;
        cursor: pointer;
        background: rgba(255, 255, 255, 0.37);
        border-radius: 16px;
    }

    &::-ms-track {
        width: 100%;
        height: 4px;
        cursor: pointer;
        border-radius: 0.4rem;
        background: transparent;
        border-color: transparent;
        color: transparent;
    }

    &::-ms-thumb {
        width: 6px;
        height: 6px;
        border-radius: 12rem;
        background-color: #fff;
        border: 0;
        box-shadow: rgba(0, 0, 0, 0.16) 0 2px 3px;
        cursor: pointer;
        transition: background-color 0.15s ease-in-out;
        margin-top: -1px;
    }

    &:focus {
        outline: 0;
    }

    &::-webkit-slider-thumb:hover {
        background-color: #F6F7F9;
    }

    &::-moz-range-thumb:hover {
        background-color: #F6F7F9;
    }

    &::-ms-thumb:hover {
        background-color: #F6F7F9;
    }

    &:focus::-webkit-slider-thumb {
        background-color: #fff;
        border: 1px solid ${color('brand.main')};
        box-shadow: ${shadow('brand')};
    }

    &:active::-webkit-slider-thumb {
        background-color: #fff;
        transition: all 0.3s ease 0s;
        transform: scale3d(1.5, 1.5, 1);
    }

    &:focus::-moz-range-thumb {
        background-color: #fff;
        border: 1px solid ${color('brand.main')};
        box-shadow: ${shadow('brand')};
    }

    &:active::-moz-range-thumb {
        background-color: #fff;
    }
`;
